import axios from 'axios';

export function DatosContribuyente(rut, callback) {
  axios({
    method: 'get',
    url: '/api/Contribuyente/Datos/' + rut
  }).then((obj) => {
    callback(obj);
  })
}

export function GetComunasByRegion(idRegion, callback) {
  axios({
    method: 'get',
    url: '/api/Generico/Comuna/' + idRegion
  }).then((obj) => {
    callback(obj);
  })
}

export function getBase64(file, callback, errorCallback) {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    if(callback){
      callback(reader.result)
    }
  };
  reader.onerror = function (error) {
    errorCallback(error);
  };
}